/* eslint-disable no-useless-catch */
import Cookies from 'js-cookie';
import fetch from 'isomorphic-fetch';

const getBaseURL = (env = 'dev') => {
  const isProduction = env === 'prod' || env === 'production';
  const baseDomain = isProduction ? 'com' : 'org';
  return `https://gateway.chotot.${baseDomain}`;
};

const request = async (url, options = {}, env) => {
  const privateToken = Cookies.get('privateToken');
  const headers = {
    ...(options.headers || {}),
    Authorization: `${privateToken ? `Bearer ${privateToken}` : ''}`,
  };

  try {
    const res = await fetch(getBaseURL(env) + url, { ...options, headers });
    const data = await res.json();

    if (res.status !== 200) {
      throw data;
    }

    return data;
  } catch (err) {
    throw err;
  }
};

export default request;
